import React from "react";
import { motion } from "framer-motion";
import profilePic from "../assets/profilepic.jpg";

const Profile: React.FC = () => {
  return (
    <motion.section
      id="about"
      className="h-screen flex flex-col justify-center px-4 md:px-12 lg:px-24 pt-32 md:pt-28"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Massive Name - Art Gallery Style */}
      <div className="flex flex-col leading-none">
        <motion.h1
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-[14vw] sm:text-[12vw] md:text-[9vw] font-display font-black text-white tracking-tighter mix-blend-difference z-10"
        >
          RAVIANSYAH
        </motion.h1>
        <motion.h1
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-[14vw] sm:text-[12vw] md:text-[9vw] font-display font-black text-zinc-500 tracking-tighter self-end -mt-2 sm:-mt-3 md:-mt-8 mix-blend-difference z-10"
        >
          NOORMAN
        </motion.h1>
      </div>

      {/* Content Grid */}
      <div className="flex flex-col md:flex-row mt-8 md:mt-12 gap-8 items-start">
        {/* Minimalist Image - Desktop Only (Left Column) */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="hidden md:block md:w-[15vw] relative"
        >
          <div className="aspect-[3/4] overflow-hidden grayscale contrast-125 hover:grayscale-0 transition-all duration-700 ease-in-out">
            <img src={profilePic} alt="Profile" className="w-full h-full object-cover" />
          </div>
        </motion.div>

        {/* Editorial Description */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="w-full md:w-1/2 flex flex-col gap-6"
        >
          <div className="border-t border-accent/20 pt-4 flex flex-row md:flex-row gap-6 items-start">
            <div className="flex-1">
              <h3 className="text-xs font-mono text-accent-dim tracking-widest uppercase mb-2">Role</h3>
              <p className="text-xl md:text-2xl font-serif text-accent leading-snug">
                Software Developer &<br />Creative Technologist
              </p>
            </div>

            {/* Minimalist Image - Mobile Only (Right of Role) */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="block md:hidden w-[20vw] relative shrink-0"
            >
              <div className="aspect-[3/4] overflow-hidden grayscale contrast-125 hover:grayscale-0 transition-all duration-700 ease-in-out">
                <img src={profilePic} alt="Profile" className="w-full h-full object-cover" />
              </div>
            </motion.div>
          </div>

          <div className="border-t border-accent/20 pt-6">
            <h3 className="text-sm font-mono text-accent-dim tracking-widest uppercase mb-4">About</h3>
            <p className="text-accent-dim text-base md:text-lg leading-relaxed max-w-4xl font-light">
              Full-stack developer experienced in building and maintaining large-scale systems using MERN, Angular, Vue.js, and React frameworks. Skilled in integrating AI wrappers with OpenAI API, microservices architecture, and modern databases (Neon, Supabase, PostgreSQL). Focused on developing intelligent, high-performance web and mobile applications from front-end to back-end.
            </p>
          </div>

          <div className="border-t border-accent/20 pt-6 flex gap-8">
            <a href="#portfolio" className="text-white hover:text-white/70 font-mono text-sm uppercase tracking-wide border-b border-transparent hover:border-white transition-all pb-1">
              Selected Works
            </a>
            <a href="#contact" className="text-white hover:text-white/70 font-mono text-sm uppercase tracking-wide border-b border-transparent hover:border-white transition-all pb-1">
              Contact
            </a>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Profile;
